import { isNil, startCase } from 'lodash';

export default {
  activeProductName: (state) => state.config.productName,
  gameTitle: (state, getters) => {
    if (!isNil(getters.customProductName)) {
      return getters.customProductName;
    }
    return getters.translateProductName && !isNil(state.config?.productNameLabel)
      ? getters.translations?.[state.config.productNameLabel] || ''
      : startCase(state.config?.productName) || '';
  },
  customProductName: (state) => state.config.ui?.config?.customProductName,
  // TODO: Remove true default when all apps adapted and ensured all clients with custom/translated product name are adapted through static config
  translateProductName: (state) => state.config.ui?.config?.translateProductName ?? true,
  labelColors: (state) => state.config.racerLabelColors,
  racers: (state) => state.config.numberOfContestants.value,
  reverseForecast: (state) => state.config.reverseForecast,
  isIsonis: (state) => state.isonisCountryList.indexOf(state.config.taxAuthority) > -1,
  isBoostActive: (state) => state.config.ui.config?.boost?.enabled || false,
  isFreeBetMode: (state) => state.isFreeBetMode,
  userIsOperator: (state) =>
    state.terminalUserData.userType === 'OPERATOR' || state.terminalUserData.type === 'OPERATOR',
  ajsDisabled: (state) => state.config?.ui?.config?.ajsDisabled ?? false,
  isNextGen: (state) => state.config.platformName === 'NextGen',
  freeBetFeatureActive: (state) => state.config.ui.config.freeBetFeatureActive,
  thirdPartyInfo: (state) => state.thirdPartyInfo,
  customDomain: (state) => state.config.customDomain,
  layout: (state) => state.layout,
  isTerminalLayout: (state) => state.layout === 'terminal',
  isTerminalChannel: (state) => state.config.applicationName.toLowerCase() === 'terminal',
  nextgenStandaloneIntegration: (state) => state.nextgenStandaloneIntegration,
  isThirdPartyIntegration: (state) => state.appMode === 'thirdPartyIntegration',
  printedTicketsByTicketCheck: (state) => state.printedTicketsByTicketCheck,
};
